'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@achra/ui/accordion';
import { useMemo } from 'react';
import { CategoryItem } from './category-item';
import type { CategoryTree } from '../../types';
interface HeadcountSectionProps {
  categories: CategoryTree[];
  onValueChange: (newValue: string[]) => void;
}
function HeadcountSection(t0) {
  const $ = _c(9);
  const {
    categories,
    onValueChange
  } = t0;
  let t1;
  if ($[0] !== categories) {
    t1 = categories.filter(_temp).map(_temp2);
    $[0] = categories;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const values = t1;
  if (categories.length === 0) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h3 className="mb-3 border-b text-lg font-bold">Headcount Expense Categories</h3>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== categories) {
    t3 = categories.map(_temp3);
    $[3] = categories;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onValueChange || $[6] !== t3 || $[7] !== values) {
    t4 = <div>{t2}<div className="w-full md:w-[calc(50%-0.5rem)]"><Accordion type="multiple" value={values} onValueChange={onValueChange}>{t3}</Accordion></div></div>;
    $[5] = onValueChange;
    $[6] = t3;
    $[7] = values;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp3(category_1) {
  return <CategoryItem key={category_1.id} category={category_1} />;
}
function _temp2(category_0) {
  return category_0.id;
}
function _temp(category) {
  return category.children.length > 0 && !category.isCollapsed;
}
export { HeadcountSection };